<template>
  <div class="container" id="top-page">
    <v-expansion-panels multiple v-model="panel">
      <v-expansion-panel>
        <v-expansion-panel-header class="Header"
          >User Management</v-expansion-panel-header
        >
        <v-expansion-panel-content>
          <h4 style="font-weight: bold">Search:</h4>
          <input
            class="form-control border input-search"
            id="myInput"
            type="text"
            v-model="search1"
          />
          <div class="filter_date">
            <div class="filter_date_item">
              <h4>From Date:</h4>
              <input type="date" v-model="fromdate1" class="input_date" />
            </div>
            <div class="filter_date_item ml-20">
              <h4>To Date:</h4>
              <input type="date" v-model="todate1" class="input_date" />
            </div>
          </div>
          <br />
          <v-data-table
            v-if="headerItemsFilterDate.length <= 0"
            item-key="name"
            class="elevation-1 table-header"
            loading
            :items-per-page="5"
            :headers="headersNotfound"
            :items="itemNotfound"
            hide-default-footer
            loading-text="Loading... Please wait"
          >
            <template v-slot:top="{ pagination, options, updateOptions }">
              <v-data-footer
                :pagination="pagination"
                :options="options"
                @update:options="updateOptions"
                items-per-page-text="$vuetify.dataTable.itemsPerPageText"
              /> </template
          ></v-data-table>
          <v-data-table
            v-else
            :items-per-page="5"
            :headers="invoiceHeader"
            :items="userData"
            hide-default-footer
            class="elevation-1 table-header"
            @click:row="handleRowClick"
          >
            <template v-slot:top="{ pagination, options, updateOptions }">
              <v-data-footer
                :pagination="pagination"
                :options="options"
                @update:options="updateOptions"
                items-per-page-text="$vuetify.dataTable.itemsPerPageText"
              />
              <v-dialog v-model="dialog" max-width="750px">
                <v-card>
                  <v-card-title>
                    <span class="text-h5">User Information</span>
                  </v-card-title>
                  <v-card-text>
                    <v-container>
                      <v-row>
                        <div v-for="(header, idx) in invoiceHeader" :key="idx">
                          <v-col cols="auto" sm="auto" md="auto">
                            <v-text-field
                              color="black"
                              v-if="checkIsEmpty(curInvoice[header.value])"
                              v-model="emptyItem"
                              :label="header.text"
                              :readonly="true"
                            ></v-text-field>
                            <v-text-field
                              color="black"
                              v-else
                              v-model="curInvoice[header.value]"
                              :label="header.text"
                              :readonly="true"
                            ></v-text-field>
                          </v-col>
                        </div>
                      </v-row>
                    </v-container>
                  </v-card-text>
                  <!-- 
                  <v-container fluid>
                    <v-row>
                      <v-col cols="12" sm="4" md="4">
                        <v-checkbox
                          v-model="ex4"
                          label="red"
                          color="red"
                          value="red"
                          hide-details
                        ></v-checkbox>
                        <v-checkbox
                          v-model="ex4"
                          label="red darken-3"
                          color="red darken-3"
                          value="red darken-3"
                          hide-details
                        ></v-checkbox>
                      </v-col>
                      <v-col cols="12" sm="4" md="4">
                        <v-checkbox
                          v-model="ex4"
                          label="indigo"
                          color="indigo"
                          value="indigo"
                          hide-details
                        ></v-checkbox>
                        <v-checkbox
                          v-model="ex4"
                          label="indigo darken-3"
                          color="indigo darken-3"
                          value="indigo darken-3"
                          hide-details
                        ></v-checkbox>
                      </v-col>
                      <v-col cols="12" sm="4" md="4">
                        <v-checkbox
                          v-model="ex4"
                          label="orange"
                          color="orange"
                          value="orange"
                          hide-details
                        ></v-checkbox>
                        <v-checkbox
                          v-model="ex4"
                          label="orange darken-3"
                          color="orange darken-3"
                          value="orange darken-3"
                          hide-details
                        ></v-checkbox>
                      </v-col>
                    </v-row>

                    <v-row class="mt-12">
                      <v-col cols="12" sm="4" md="4">
                        <v-checkbox
                          v-model="ex4"
                          label="primary"
                          color="primary"
                          value="primary"
                          hide-details
                        ></v-checkbox>
                        <v-checkbox
                          v-model="ex4"
                          label="secondary"
                          color="secondary"
                          value="secondary"
                          hide-details
                        ></v-checkbox>
                      </v-col>
                      <v-col cols="12" sm="4" md="4">
                        <v-checkbox
                          v-model="ex4"
                          label="success"
                          color="success"
                          value="success"
                          hide-details
                        ></v-checkbox>
                        <v-checkbox
                          v-model="ex4"
                          label="info"
                          color="info"
                          value="info"
                          hide-details
                        ></v-checkbox>
                      </v-col>
                      <v-col cols="12" sm="4" md="4">
                        <v-checkbox
                          v-model="ex4"
                          label="warning"
                          color="warning"
                          value="warning"
                          hide-details
                        ></v-checkbox>
                        <v-checkbox
                          v-model="ex4"
                          label="error"
                          color="error"
                          value="error"
                          hide-details
                        ></v-checkbox>
                      </v-col>
                    </v-row>
                  </v-container> -->

                  <v-card-actions>
                    <v-btn color="blue darken-1" text @click="close">
                      OK
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </template>
            <template
              v-for="header in invoiceHeader"
              v-slot:[`item.${header.value}`]="{ item }"
            >
              <template v-if="isBoolean(item[header.value])">
                <v-checkbox
                  v-bind:key="item[header.value]"
                  v-model="item[header.value]"
                  :true-value="true"
                  :false-value="false"
                  light
                  disabled
                  color="black"
                ></v-checkbox>
              </template>
              <template v-else>
                {{ item[header.value] }}
              </template>
            </template>
          </v-data-table>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
// import tableComponent from "../table/tableComponent.vue";
import { mapGetters } from "vuex";
import DecodeJWT from "../DecodeJWT";

export default {
  // components: { tableComponent },
  mounted() {
    let token = localStorage.getItem("token");
    if (token == "" || !token) {
      this.$router.push("/login");
    } else {
      var info = DecodeJWT(token);
      if (info.exp <= new Date().getTime() / 1000) {
        this.$router.push("/login");
      } else {
        window.scrollTo({
          top: document.getElementById("top-page").offsetTop,
          left: 0,
          behavior: "smooth",
        });
        this.panel = Array.from(Array(2).keys());
        this.getBAQInvoice();
        const today = new Date();
        const fromday = new Date();
        fromday.setMonth(fromday.getMonth() - 3);
        let year = today.getFullYear();
        let month = (today.getMonth() + 1).toString().padStart(2, "0");
        let day = today.getDate().toString().padStart(2, "0");
        this.todate1 = this.todate2 = `${year}-${month}-${day}`;
        year = fromday.getFullYear();
        month = (fromday.getMonth() + 1).toString().padStart(2, "0");
        day = fromday.getDate().toString().padStart(2, "0");
        this.fromdate1 = this.fromdate2 = `${year}-${month}-${day}`;
      }
    }
  },
  data() {
    return {
      ex4: [
        "red",
        "indigo",
        "orange",
        "primary",
        "secondary",
        "success",
        "info",
        "warning",
        "error",
        "red darken-3",
        "indigo darken-3",
        "orange darken-3",
      ],
      userData: [
        {
          id: "user01",
          fullname: "Huỳnh Gia Phú",
          dob: "27/10/2002",
          phoneNumber: "0911623609",
          address: "60/7 Ung Văn Khiêm, Bình Thạnh",
          numberOfOrders: 38,
        },
        {
          id: "user02",
          fullname: "John Cena",
          dob: "22/11/1986",
          phoneNumber: "01846623585",
          address: "123 Main Street Austin, TX 7701, Texas",
          numberOfOrders: 20,
        },
        {
          id: "user03",
          fullname: "張新成",
          dob: "12/07/1993",
          phoneNumber: "13812345678",
          address: "上海市黄浦区南京东路456号",
          numberOfOrders: 11,
        },
        {
          id: "user04",
          fullname: "Élise Martin",
          dob: "01/02/2001",
          phoneNumber: "05238842563",
          address: "3 Rue de la République, Lyon",
          numberOfOrders: 5,
        },
      ],
      headersNotfound: [{ text: "", value: "nf" }],
      itemNotfound: [{ nf: "Data not found!" }],
      invoiceHeader: [
        { text: "ID", value: "id" },
        { text: "Full Name", value: "fullname" },
        { text: "Date Of Birth", value: "dob" },
        { text: "Phone Number", value: "phoneNumber" },
        { text: "Address", value: "address" },
        { text: "Number Of Orders", value: "numberOfOrders" },
      ],
      invoiceDetail: [
        { text: "Invoice Line", value: "InvcDtl_InvoiceLine" },
        { text: "Description", value: "InvcDtl_LineDesc" },
        { text: "Type", value: "InvcDtl_LineType" },
        { text: "Doc Unit Price", value: "InvcDtl_DocUnitPrice" },
        { text: "UOM", value: "InvcDtl_IUM" },
        { text: "Order Num", value: "InvcDtl_OrderNum" },
        { text: "Order Line", value: "InvcDtl_OrderLine" },
        { text: "Part", value: "InvcDtl_PartNum" },
        { text: "Part Description", value: "Part_PartDescription" },
      ],
      headerItems: [],
      detailItems: [],
      panel: [],
      curInvoice: {},
      search1: "",
      search2: "",
      dialog: false,
      emptyItem: " ",
      fromdate1: "",
      todate1: "",
      fromdate2: "",
      todate2: "",
    };
  },
  watch: {
    loader() {
      const l = this.loader;
      this[l] = !this[l];

      setTimeout(() => (this[l] = false), 3000);

      this.loader = null;
    },
    getInvoiceHeader() {
      this.loadHeader();
    },
    getInvoiceDtl() {
      this.loadDetail();
    },
  },
  computed: {
    ...mapGetters("User", ["getUserInfo"]),
    ...mapGetters("Data", ["getInvoiceHeader", "getInvoiceDtl"]),
    headerItemsFilter() {
      const filterKey = (this.search1 || "").toLowerCase();
      if (this.headerItems == null || filterKey === "") return this.headerItems;
      return this.headerItems.filter((i) => {
        return (
          i.InvcHead_InvoiceNum.toString().toLowerCase().indexOf(filterKey) >
            -1 ||
          i.InvcHead_OrderNum.toString().toLowerCase().indexOf(filterKey) > -1
        );
      });
    },
    headerItemsFilterDate() {
      if (this.headerItemsFilter.length > 0) {
        let from = new Date(this.fromdate1);
        let to = new Date(this.todate1);
        return this.headerItemsFilter.filter((i) => {
          let day = i.InvcHead_InvoiceDate.split("/")[0];
          let month = i.InvcHead_InvoiceDate.split("/")[1];
          let year = i.InvcHead_InvoiceDate.split("/")[2];
          let date = new Date(year, month - 1, day);
          return date <= to && from <= date;
        });
      } else {
        return this.headerItemsFilter;
      }
    },
    detailItemsFilter() {
      const filterKey = (this.search2 || "").toLowerCase();
      if (this.detailItems == null || filterKey === "") return this.detailItems;
      return this.detailItems.filter((i) => {
        return (
          i.InvcDtl_InvoiceLine.toString().toLowerCase().indexOf(filterKey) >
            -1 ||
          i.InvcDtl_LineDesc.toString().toLowerCase().indexOf(filterKey) > -1 ||
          i.InvcDtl_LineType.toString().toLowerCase().indexOf(filterKey) > -1
        );
      });
    },
    detailItemsFilterDate() {
      if (this.detailItemsFilter.length > 0) {
        // let from = new Date(this.fromdate2);
        // let to = new Date(this.todate2)
        // return this.detailItemsFilter.filter((i) => {
        //   let day = i.InvcHead_InvoiceDate.split('/')[0];
        //   let month = i.InvcHead_InvoiceDate.split('/')[1];
        //   let year = i.InvcHead_InvoiceDate.split('/')[2];
        //   let date = new Date(year, month-1, day);
        //   return date <= to && from <= date;
        // });
        return this.detailItemsFilter;
      } else {
        return this.detailItemsFilter;
      }
    },
  },
  methods: {
    close() {
      this.dialog = false;
    },
    isBoolean(value) {
      return typeof value === "boolean";
    },
    checkIsEmpty(value) {
      if (typeof value === "string") {
        if (value.length == 0) return true;
        return false;
      }
      if (typeof value === "boolean") {
        return false;
      }
      return false;
    },
    seeDetail() {
      this.dialog = false;
      this.getBAQInvoiceDetail(this.curInvoice);
      window.scrollTo({
        top: document.getElementById("detail").offsetTop,
        left: 0,
        behavior: "smooth",
      });
    },
    handleRowClick(item) {
      this.curInvoice = item;
      this.dialog = true;
    },
    convertDate(stringdate) {
      if (stringdate) {
        var dateObject = new Date(stringdate);
        var day = dateObject.getDate().toString().padStart(2, "0");
        var month = (dateObject.getMonth() + 1).toString().padStart(2, "0");
        var year = dateObject.getFullYear();
        return `${day}/${month}/${year}`;
      } else return "";
    },
    async getBAQInvoice() {
      await this.$store.dispatch("Data/getOpenInvoiceData");
      this.loadHeader();
    },
    async getBAQInvoiceDetail(item) {
      await this.$store.dispatch("Data/getPaidInvoiceData", {
        invoiceid: item.InvcHead_InvoiceNum,
      });
      this.loadDetail();
    },
    loadHeader() {
      this.headerItems = [];
      if (this.getInvoiceHeader && this.getInvoiceHeader.length > 0) {
        this.getInvoiceHeader.forEach((el) => {
          this.headerItems.push({
            InvcHead_InvoiceDate: this.convertDate(el.InvcHead_InvoiceDate),
            InvcHead_DueDate: this.convertDate(el.InvcHead_DueDate),
            InvcHead_InvoiceNum: el.InvcHead_InvoiceNum,
            InvcHead_OrderNum: el.InvcHead_OrderNum,
            InvcHead_DocInvoiceBal: el.InvcHead_DocInvoiceBal,
            InvcHead_PONum: el.InvcHead_PONum,
            InvcHead_DocInvoiceAmt: el.InvcHead_DocInvoiceAmt,
            InvcHead_CurrencyCode: el.InvcHead_CurrencyCode,
          });
        });
      }
    },
    loadDetail() {
      this.detailItems = [];
      if (this.getInvoiceDtl && this.getInvoiceDtl.length > 0) {
        this.getInvoiceDtl.forEach((el) => {
          this.detailItems.push({
            InvcDtl_InvoiceLine: el.InvcDtl_InvoiceLine,
            InvcDtl_LineDesc: el.InvcDtl_LineDesc,
            InvcDtl_LineType: el.InvcDtl_LineType,
            InvcDtl_DocUnitPrice: el.InvcDtl_DocUnitPrice,
            InvcDtl_IUM: el.InvcDtl_IUM,
            InvcDtl_OrderNum: el.InvcDtl_OrderNum,
            InvcDtl_OrderLine: el.InvcDtl_OrderLine,
            InvcDtl_PartNum: el.InvcDtl_PartNum,
            Part_PartDescription: el.Part_PartDescription,
          });
        });
      }
    },
  },
};
</script>

<style scoped>
.table td {
  white-space: nowrap;
  text-overflow: ellipsis;
}

.ml-20 {
  margin-left: 100px;
}

.input_date {
  outline: #d1dfe3;
}

.filter_date {
  display: flex;
  flex-direction: row;
}

.filter_date_item {
  display: flex;
  flex-direction: column;
}

.mb-20 {
  margin-bottom: 50px;
}

.Header {
  font-weight: 700;
  font-size: 1.2em;
  color: white;
  background-color: #d1dfe3;
  color: black;
}

.table-custom {
  width: 100%;
  margin-top: 20px;
}

table,
th,
td {
  border: 1px solid #ddd;

  border-collapse: collapse;
}

th {
  border-bottom: 2px solid black;
}

td {
  text-align: center;
}

.input-search {
  margin-top: 5px;
  margin-bottom: 10px;
  outline: #d1dfe3;
  border-style: solid;
  border-width: 1px;
  border-radius: 5px;
  border-color: #ddd;
}

.hidden {
  display: none !important;
}

a:hover {
  font-weight: bolder;
}

.switchTabMsg {
  text-align: center;
  width: fit-content;
  color: black !important;
  text-decoration: underline;
}

.passwordRules {
  margin-top: -25px;
  margin-left: 15px;
  font-size: small;
  opacity: 0.6;
}
</style>
